module.exports = __webpack_public_path__ + "static/media/4.f807e2e3.svg";